import { BpIconTypes } from '../types';
import React from 'react';

import { DataExtracts } from './DataExtractsIcon';
import { ReportsIcon } from './ReportsSvg';
import { DocumentsCheckIcon } from './DocumentsCheckIcon';
import { DocumentCandidateSearch } from './DocumentCandidateSearchIcon';
import { JobApplication } from './JobApplicationIcon';
import { Invoice } from './InvoiceIcon';
import { TimeExpenses } from './TimeExpensesIcon';
import { AddTimeIcon } from './AddTimeIcon';
import { TwitterIcon } from './TwitterIcon';
import { FacebookIcon } from './FacebookIcon';
import { LinkedInIcon } from './LinkedInIcon';
import { AddExpenseIcon } from './AddExpenseIcon';
import { FactCheckIcon } from './FactCheck';
import { JobPostingIcon } from './JobPostingIcon';
import { PaidIcon } from './PaidIcon';
import { TimeAllocationIcon } from './TimeAllocationIcon';
import { SyncInfoIcon } from './SyncInfoIcon';
import { WorkCustomIcon } from './WorkCustomIcon';

export const BpIcons: { [key in BpIconTypes]: React.JSX.Element } = {
  data_extracts_custom: <DataExtracts />,
  reports_custom: <ReportsIcon />,
  documents_check_custom: <DocumentsCheckIcon />,
  document_candidate_search_custom: <DocumentCandidateSearch />,
  job_application_custom: <JobApplication />,
  invoice_custom: <Invoice />,
  time_expense_custom: <TimeExpenses />,
  add_time_custom: <AddTimeIcon />,
  twitter_custom: <TwitterIcon />,
  facebook_custom: <FacebookIcon />,
  linked_in_custom: <LinkedInIcon />,
  add_expense_custom: <AddExpenseIcon />,
  fact_check_custom: <FactCheckIcon />,
  job_posting_custom: <JobPostingIcon />,
  paid_custom: <PaidIcon />,
  time_allocation_custom: <TimeAllocationIcon />,
  sync_info_custom: <SyncInfoIcon />,
  work_custom: <WorkCustomIcon />
};
